<template>
    <div class="config">
        <el-card class="config-card-box">
            <el-form :model="params" :rules="configRules" ref="form">
                <basis-config :params="params" :is_configured="is_configured"></basis-config>
                <no-identified :params="params" :is_configured="is_configured"></no-identified>
                <h3>3.已认证玩家配置

                    <el-tooltip placement="top" content="年龄配置规则：配置年龄范围是包含开始年龄，不包含结束年龄的。">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </h3>
                <el-collapse v-model="params.names" v-if="is_configured">
                    <el-collapse-item :name="i" v-for="(item,i) in params.identified_user_rules"
                                      :key="'identified_user_rules'+i">
                        <template slot="title">
                            <div class="flex title-change-btn">
                                <div style="padding-left: 15px;">
                                    年龄：


                                    <el-form-item class="form-inline"
                                                  :prop="'identified_user_rules.' + i + '.age_from'"
                                                  :rules="{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }">
                                        <el-select size="mini" v-model="item.age_from"
                                                   @change="changeAgeFrom($event, item)">
                                            <el-option v-for="(_,key) in 26"
                                                       :disabled="i > 0 && key < params.identified_user_rules[i-1].age_to"
                                                       :key="_"
                                                       :value="key"
                                                       :label="key+'岁'"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <span style="margin: 0 8px">至</span>
                                    <el-form-item class="form-inline"
                                                  :prop="'identified_user_rules.' + i + '.age_to'"
                                                  :rules="{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }">
                                        <el-select size="mini" v-model="item.age_to">
                                            <el-option v-for="i in 25"
                                                       :disabled="item.age_from > 0 && i <= item.age_from"
                                                       :key="i"
                                                       :value="i"
                                                       :label="i+'岁'"
                                            ></el-option>
                                            <el-option label="26岁及以上" :value="150"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="flex" style="margin-right: 15px">
                                    <el-button
                                            type="primary"
                                            icon="el-icon-circle-plus-outline"
                                            @click.stop="handleAddAgeRange"
                                            size="small"
                                    ></el-button>
                                    <el-button
                                            type="danger"
                                            icon="el-icon-delete"
                                            v-if="i"
                                            @click.stop="handleDeleteAgeRange(i)"
                                            size="small"
                                    ></el-button>
                                </div>
                            </div>
                        </template>
                        <div class="border-card mar-t-0">
                            <el-form-item label="限制类型："
                                          :prop="'identified_user_rules.' + i + '.limit_type'"
                                          :rules="{
                                    required: true, message: ' ', trigger: ['blur', 'change']
                                }">
                                <el-checkbox-group v-model="item.limit_type">
                                    <el-checkbox :label="1">登录限制</el-checkbox>
                                    <el-checkbox :label="2">消费限制</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <template v-if="item.limit_type.indexOf(1) > -1">
                                <el-form-item label="节假日登录限制：" class="greenitem"></el-form-item>
                                <div v-for="(timeRange,timeIndex) in item.login_rule.holiday.rules"
                                     :key="'timeRange'+ timeIndex">
                                    <el-form-item
                                            class="form-inline"
                                            :prop="'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.date_type'"
                                            :rules="{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }">
                                        <el-select size="mini" v-model="timeRange.date_type"
                                                   @visible-change="changeTimeRange($event, item,'holiday')">
                                            <el-option v-for="(obj,index) in item.login_rule.holiday.changeTimeOptions"
                                                       :key="'change_time_option' + index"
                                                       :label="obj.label"
                                                       :value="obj.value"
                                                       :disabled="obj.disable"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <template v-if="timeRange.date_type === 1">
                                        当天累计登陆上限


                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.daily_max_game_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-input-number class="w70" size="mini" :min="0" :precision="0"
                                                             :controls="false"
                                                             v-model="timeRange.daily_max_game_time"></el-input-number>
                                        </el-form-item>
                                        min


                                    </template>
                                    <template v-else-if="timeRange.date_type === 2">
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.start_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="起始时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRange.start_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end:    timeRange.end_time ? timeRange.end_time : '24:00',
                                                maxTime: timeRange.end_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        <span style="margin: 0 8px">至</span>
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.end_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="结束时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRange.end_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end: '24:00',
                                                minTime: timeRange.start_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        强制玩家离线


                                    </template>
                                    <template v-else-if="timeRange.date_type === 3">
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.start_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="起始时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRange.start_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end:    timeRange.end_time ? timeRange.end_time : '24:00',
                                                maxTime: timeRange.end_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        <span style="margin: 0 8px">至</span>
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.holiday.rules.'+ timeIndex +'.end_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="结束时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRange.end_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end: '24:00',
                                                minTime: timeRange.start_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        玩家可以登陆


                                    </template>
                                    <i class="el-icon-circle-plus-outline"
                                       @click="handleAddTimeRange(item,'holiday')"></i>
                                    <i class="el-icon-delete" @click="handleDeleteTimeRange(item, timeIndex,'holiday')"
                                       v-if="timeIndex"></i>
                                </div>


                                <el-form-item label="非节假日（周五）登录限制：" class="greenitem"></el-form-item>
                                <div v-for="(timeRangeSpecial,timeIndex) in item.login_rule.work_day_special.rules"
                                     :key="'timeRangeSpecial'+ timeIndex">
                                    <el-form-item
                                            class="form-inline"
                                            :prop="'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.date_type'"
                                            :rules="{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }">
                                        <el-select size="mini" v-model="timeRangeSpecial.date_type"
                                                   @visible-change="changeTimeRange($event, item,'work_day_special')">
                                            <el-option
                                                    v-for="(obj,index) in item.login_rule.work_day_special.changeTimeOptions"
                                                    :key="'change_time_option' + index"
                                                    :label="obj.label"
                                                    :value="obj.value"
                                                    :disabled="obj.disable"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <template v-if="timeRangeSpecial.date_type === 1">
                                        当天累计登陆上限


                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.daily_max_game_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-input-number class="w70" size="mini" :min="0" :precision="0"
                                                             :controls="false"
                                                             v-model="timeRangeSpecial.daily_max_game_time"></el-input-number>
                                        </el-form-item>
                                        min


                                    </template>
                                    <template v-else-if="timeRangeSpecial.date_type === 2">
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.start_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="起始时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRangeSpecial.start_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end:    timeRangeSpecial.end_time ? timeRangeSpecial.end_time : '24:00',
                                                maxTime: timeRangeSpecial.end_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        <span style="margin: 0 8px">至</span>
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.end_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="结束时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRangeSpecial.end_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end: '24:00',
                                                minTime: timeRangeSpecial.start_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        强制玩家离线


                                    </template>
                                    <template v-else-if="timeRangeSpecial.date_type === 3">
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.start_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="起始时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRangeSpecial.start_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end:    timeRangeSpecial.end_time ? timeRangeSpecial.end_time : '24:00',
                                                maxTime: timeRangeSpecial.end_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        <span style="margin: 0 8px">至</span>
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_special.rules.'+ timeIndex +'.end_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="结束时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRangeSpecial.end_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end: '24:00',
                                                minTime: timeRangeSpecial.start_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        玩家可以登陆


                                    </template>
                                    <i class="el-icon-circle-plus-outline"
                                       @click="handleAddTimeRange(item,'work_day_special')"></i>
                                    <i class="el-icon-delete"
                                       @click="handleDeleteTimeRange(item, timeIndex,'work_day_special')"
                                       v-if="timeIndex"></i>
                                </div>


                                <el-form-item label="非节假日（非周五）登录限制：" class="greenitem"></el-form-item>
                                <div v-for="(timeRangeNormal,timeIndex) in item.login_rule.work_day_normal.rules"
                                     :key="'timeRangeNormal'+ timeIndex">
                                    <el-form-item
                                            class="form-inline"
                                            :prop="'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.date_type'"
                                            :rules="{
                                            required: true, message: ' ', trigger: ['blur', 'change']
                                        }">
                                        <el-select size="mini" v-model="timeRangeNormal.date_type"
                                                   @visible-change="changeTimeRange($event, item,'work_day_normal')">
                                            <el-option
                                                    v-for="(obj,index) in item.login_rule.work_day_normal.changeTimeOptions"
                                                    :key="'change_time_option' + index"
                                                    :label="obj.label"
                                                    :value="obj.value"
                                                    :disabled="obj.disable"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <template v-if="timeRangeNormal.date_type === 1">
                                        当天累计登陆上限


                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.daily_max_game_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-input-number class="w70" size="mini" :min="0" :precision="0"
                                                             :controls="false"
                                                             v-model="timeRangeNormal.daily_max_game_time"></el-input-number>
                                        </el-form-item>
                                        min


                                    </template>
                                    <template v-else-if="timeRangeNormal.date_type === 2">
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.start_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="起始时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRangeNormal.start_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end:    timeRangeNormal.end_time ? timeRangeNormal.end_time : '24:00',
                                                maxTime: timeRangeNormal.end_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        <span style="margin: 0 8px">至</span>
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.end_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="结束时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRangeNormal.end_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end: '24:00',
                                                minTime: timeRangeNormal.start_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        强制玩家离线


                                    </template>
                                    <template v-else-if="timeRangeNormal.date_type === 3">
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.start_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="起始时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRangeNormal.start_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end:    timeRangeNormal.end_time ? timeRangeNormal.end_time : '24:00',
                                                maxTime: timeRangeNormal.end_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        <span style="margin: 0 8px">至</span>
                                        <el-form-item
                                                class="form-inline"
                                                :prop="'identified_user_rules.' + i + '.login_rule.work_day_normal.rules.'+ timeIndex +'.end_time'"
                                                :rules="{
                                                required: true, message: ' ', trigger: ['blur', 'change']
                                            }">
                                            <el-time-select
                                                    placeholder="结束时间"
                                                    size="mini"
                                                    class="w120"
                                                    v-model="timeRangeNormal.end_time"
                                                    :picker-options="{
                                                start: '00:00',
                                                step: '00:15',
                                                end: '24:00',
                                                minTime: timeRangeNormal.start_time
                                            }">
                                            </el-time-select>
                                        </el-form-item>
                                        玩家可以登陆


                                    </template>
                                    <i class="el-icon-circle-plus-outline"
                                       @click="handleAddTimeRange(item,'work_day_normal')"></i>
                                    <i class="el-icon-delete"
                                       @click="handleDeleteTimeRange(item, timeIndex,'work_day_normal')"
                                       v-if="timeIndex"></i>
                                </div>
                            </template>
                            <template v-if="item.limit_type.indexOf(2) > -1">
                                <el-form-item label="消费限制：" class="greenitem"></el-form-item>
                                <el-form-item label="单笔单次消费上限金额："
                                              :prop="'identified_user_rules.' + i + '.payment_rule.max_consume_per_order'"
                                              :rules="{
                                        required: true, message: ' ', trigger: ['blur', 'change']
                                    }">
                                    <el-input-number class="w70" size="mini" :min="0" :precision="2" :controls="false"
                                                     v-model="item.payment_rule.max_consume_per_order"></el-input-number>
                                    RMB


                                </el-form-item>
                                <el-form-item label="单月累计消费上限金额："
                                              :prop="'identified_user_rules.' + i + '.payment_rule.max_consume_per_month'"
                                              :rules="{
                                        required: true, message: ' ', trigger: ['blur', 'change']
                                    }">
                                    <el-input-number class="w70" size="mini" :min="0" :precision="2" :controls="false"
                                                     v-model="item.payment_rule.max_consume_per_month"></el-input-number>
                                    RMB


                                </el-form-item>
                            </template>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <identified :params="params" v-else></identified>
            </el-form>
            <template v-if="!goToConfigure">
                <div class="submit-btn-box" v-if="is_configured">
                    <el-button type="primary" size="small" @click="submit">保存</el-button>
                    <el-button type="info" size="small" @click="initAntiAddictionConfig(false)">取消</el-button>
                </div>
                <div class="submit-btn-box" v-else>
                    <el-button type="primary" size="small" @click="initAntiAddictionConfig(true)">编辑</el-button>
                </div>
            </template>
            <div class="submit-btn-box" v-else-if="isConfigBtn">
                <el-button type="primary" size="small" @click="openConfig">去配置</el-button>
            </div>
        </el-card>
    </div>
</template>
<script>
    import {mapActions, mapState} from 'vuex';
    import basisConfig from './basisConfig';
    import noIdentified from "./noIdentified";
    import identified from "./identified";
    import {cloneDeep} from "lodash";
    const requiredConfig = [{required: true, message: ' '}];
    export default {
        name: "config",
        components: {
            basisConfig,
            noIdentified,
            identified
        },
        props: {
            goToConfigure: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(['$activeGameCode', '$isGameAdmin', '$isAdmin', '$roles']),
            isConfigBtn() {
                if (this.goToConfigure && (this.$isAdmin || this.$isGameAdmin &&
                        (this.$roles.indexOf('ROLE_APP_ODP5_CUSTOM_ANTIADDICTION') > -1 ||
                        this.$roles.indexOf('ROLE_APP_ODP5_CUSTOM_ANTIADDICTION_CONFIGURATION') > -1)
                    )) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        data() {
            return {
                params: {
                    names: [],
                    regular_timing_from: '',
                    force_offline_notice_before_minutes: undefined,
                    no_identified_user_rule: {
                        timing_period_days: undefined,
                        total_game_minutes: undefined
                    },
                    identified_user_rules: [{
                        age_from: "",
                        age_to: "",
                        limit_type: [1, 2],
                        payment_rule: {
                            currency_type: 1,
                            max_consume_per_order: '',
                            max_consume_per_month: ''
                        },
                        login_rule: {
                            holiday: {
                                rules: [this.initLoginRules({}).login_rule],
                                changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                            },
                            work_day_normal: {
                                rules: [this.initLoginRules({}).login_rule],
                                changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                            },
                            work_day_special: {
                                rules: [this.initLoginRules({}).login_rule],
                                changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                            }
                        },
                        changeTimeOptions: {
                            holiday: this.initLoginRules({}).changeTimeOptions,
                            work_day_normal: this.initLoginRules({}).changeTimeOptions,
                            work_day_special: this.initLoginRules({}).changeTimeOptions
                        }
                    }]
                },
                is_configured: false,
                is_edit: true,
                configRules: {
                    force_offline_notice_before_minutes: requiredConfig,
                    'no_identified_user_rule.timing_period_days': requiredConfig,
                    'no_identified_user_rule.total_game_minutes': requiredConfig
                }
            };
        },
        methods: {
            ...mapActions('antiAddictionConfiguration', ['updateAntiAddictionConfig', 'getAntiAddictionConfig']),
            openConfig() {
                let url = '/antiaddiction/configuration.html?game_code=' + this.$activeGameCode
                window.open(url);
            },
            initLoginRules({...options}) {
                return {
                    login_rule: {
                        date_type: options.date_type,
                        daily_max_game_time: options.daily_max_game_time,
                        start_time: options.start_time,
                        end_time: options.end_time
                    },
                    changeTimeOptions: [{
                        label: '累计可玩时长',
                        value: 1,
                        disable: false
                    }, {
                        label: '指定时间不可登陆',
                        value: 2,
                        disable: false
                    }, {
                        label: '指定时间可登陆',
                        value: 3,
                        disable: false
                    }]
                };
            },
            handleAddTimeRange(currentAgeRange, type) {
                if (type === "holiday") {
                    currentAgeRange.login_rule.holiday.rules.push(this.initLoginRules({}).login_rule)
                } else if (type === "work_day_normal") {
                    currentAgeRange.login_rule.work_day_normal.rules.push(this.initLoginRules({}).login_rule)
                } else if (type === "work_day_special") {
                    currentAgeRange.login_rule.work_day_special.rules.push(this.initLoginRules({}).login_rule)
                }
            },
            handleDeleteTimeRange(item, timeIndex, type) {
                if (type === "holiday") {
                    item.login_rule.holiday.rules.splice(timeIndex, 1);
                    this.changeTimeRange(false, item, "holiday")
                }
                else if (type === "work_day_normal") {
                    item.login_rule.work_day_normal.rules.splice(timeIndex, 1);
                    this.changeTimeRange(false, item, "work_day_normal")
                } else if (type === "work_day_special") {
                    item.login_rule.work_day_special.rules.splice(timeIndex, 1);
                    this.changeTimeRange(false, item, "work_day_special")
                }
            },
            handleAddAgeRange() {
                this.params.names.push(this.params.identified_user_rules.length)
                this.params.identified_user_rules.push({
                    age_from: "",
                    age_to: "",
                    limit_type: [1, 2],
                    payment_rule: {
                        currency_type: 1,
                        max_consume_per_order: '',
                        max_consume_per_month: ''
                    },
                    login_rule: {
                        holiday: {
                            rules: [this.initLoginRules({}).login_rule],
                            changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                        },
                        work_day_normal: {
                            rules: [this.initLoginRules({}).login_rule],
                            changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                        },
                        work_day_special: {
                            rules: [this.initLoginRules({}).login_rule],
                            changeTimeOptions: this.initLoginRules({}).changeTimeOptions
                        }
                    },
                    changeTimeOptions: {
                        holiday: this.initLoginRules({}).changeTimeOptions,
                        work_day_normal: this.initLoginRules({}).changeTimeOptions,
                        work_day_special: this.initLoginRules({}).changeTimeOptions
                    }
                })
            },
            handleDeleteAgeRange(index) {
                this.params.identified_user_rules.splice(index, 1);
                if (this.params.names.indexOf(index) > -1) {
                    this.params.names.splice(this.params.names.indexOf(index), 1);
                }
            },
            submit() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        /**
                         * check ages
                         * */
                        this.params.identified_user_rules.forEach((item, i) => {
                            if (i && item.age_from < this.params.identified_user_rules[i - 1].age_to) {
                                this.$alert(`${item.age_from}岁 至 ${item.age_to}岁的年龄有重合，请重新配置！`, '提示');
                                throw '年龄重合';
                            }
                        })
                        if (this.params.no_identified_user_rule.timing_period_days * this.params.no_identified_user_rule.total_game_minutes
                            > this.params.no_identified_user_rule.timing_period_days * 1440) {
                            this.$alert('未认证玩家配置中的累计登录时长应小于配置天数的总时长！', '提示');
                            return false;
                        }

                        this.updateAntiAddictionConfig({
                            params: this.params,
                            is_edit: this.is_edit
                        }).then(() => {
                            this.$alert('保存成功！', '提示')
                            this.is_configured = false;
                        })
                    } else {
                        this.$alert('请您完善配置！', '提示')
                    }
                })

            },
            changeTimeRange(event, item, type) {
                if (!event) {
                    /*
                     const currentAgeRangeTypes =  item.login_rule.map(item => item.date_type);
                     item.changeTimeOptions.forEach(keys => {
                     keys.disable = !!(currentAgeRangeTypes.indexOf(keys.value) > -1 && keys.value !== 3);
                     })
                     if(currentAgeRangeTypes.indexOf(1) > -1 || currentAgeRangeTypes.indexOf(2) > -1) {
                     item.changeTimeOptions[3].disable = true
                     }
                     if(currentAgeRangeTypes.indexOf(4) > -1 ) {
                     item.changeTimeOptions[0].disable = true
                     item.changeTimeOptions[1].disable = true
                     }
                     */
                    if (type === "holiday") {
                        const currentAgeRangeTypes = item.login_rule.holiday.rules.map(item => item.date_type);
                        item.login_rule.holiday.changeTimeOptions.forEach(keys => {
                            keys.disable = !!(currentAgeRangeTypes.indexOf(keys.value) > -1 && (keys.value === 1));
                        })
                        if (currentAgeRangeTypes.indexOf(1) > -1) {
                            item.login_rule.holiday.changeTimeOptions[0].disable = true
                        }
                    } else if (type === "work_day_normal") {
                        const currentAgeRangeTypes = item.login_rule.work_day_normal.rules.map(item => item.date_type);
                        item.login_rule.work_day_normal.changeTimeOptions.forEach(keys => {
                            keys.disable = !!(currentAgeRangeTypes.indexOf(keys.value) > -1 && (keys.value === 1));
                        })
                        if (currentAgeRangeTypes.indexOf(1) > -1) {
                            item.login_rule.work_day_normal.changeTimeOptions[0].disable = true
                        }
                    } else if (type === "work_day_special") {
                        const currentAgeRangeTypes = item.login_rule.work_day_special.rules.map(item => item.date_type);
                        item.login_rule.work_day_special.changeTimeOptions.forEach(keys => {
                            keys.disable = !!(currentAgeRangeTypes.indexOf(keys.value) > -1 && (keys.value === 1));
                        })
                        if (currentAgeRangeTypes.indexOf(1) > -1) {
                            item.login_rule.work_day_special.changeTimeOptions[0].disable = true
                        }
                    }

                }
            },
            changeAgeFrom(e, item) {
                if (item.age_to <= e) {
                    item.age_to = '';
                }
            },
            initAntiAddictionConfig(isEdit = false) {
                this.getAntiAddictionConfig().then(res => {
                    const data = cloneDeep(res.data);
                    /**
                     * daily_max_game_minutes_of_natural_day  = 4
                     * forbidden_game_minutes_periods = 3
                     * daily_max_game_minutes_of_work_day = 2
                     * daily_max_game_minutes_of_holiday  = 1
                     *
                     * daily_max_game_minutes = 1
                     * forbidden_game_minutes_periods = 2
                     * allow_game_minutes_periods =  3
                     * */
                    console.log("res.data");
                    console.log(res.data);
                    res.data.identified_user_rules.forEach((item, index) => {
                        /*
                         if(!Array.isArray(data.identified_user_rules[index].login_rule.holiday)){
                         data.identified_user_rules[index].login_rule.holiday = [];
                         }
                         if (!Array.isArray(data.identified_user_rules[index].login_rule.work_day_normal)) {
                         data.identified_user_rules[index].login_rule.work_day_normal = [];
                         }
                         if (!Array.isArray(data.identified_user_rules[index].login_rule.work_day_special)) {
                         data.identified_user_rules[index].login_rule.work_day_special = [];
                         }*/

                        data.identified_user_rules[index].limit_type = item.limit_type;

                        //holiday......
                        console.log("holiday......");
                        data.identified_user_rules[index].login_rule.holiday.changeTimeOptions = this.initLoginRules({}).changeTimeOptions;
                        data.identified_user_rules[index].login_rule.holiday.rules = [];
                        console.log(data.identified_user_rules[index]);

                        const keys = Object.keys(item.login_rule.holiday);
                        console.log(keys);

                        keys.forEach(key => {
                            if (key === 'daily_max_game_minutes') {
                                data.identified_user_rules[index].login_rule.holiday.rules.push(
                                    this.initLoginRules({
                                        date_type: 1,
                                        daily_max_game_time: item.login_rule.holiday[key]
                                    }).login_rule
                                )
                            }
                        });
                        console.log(data.identified_user_rules[index]);

                        this.changeTimeRange(false, data.identified_user_rules[index], 'holiday');
                        if (Array.isArray(item.login_rule.holiday.forbidden_game_minutes_periods) &&
                            item.login_rule.holiday.forbidden_game_minutes_periods.length) {
                            item.login_rule.holiday.forbidden_game_minutes_periods.forEach(times => {
                                data.identified_user_rules[index].login_rule.holiday.rules.push(
                                    this.initLoginRules({
                                        date_type: 2,
                                        start_time: times[0],
                                        end_time: times[1]
                                    }).login_rule
                                )
                            })
                        }
                        if (Array.isArray(item.login_rule.holiday.allow_game_minutes_periods) &&
                            item.login_rule.holiday.allow_game_minutes_periods.length) {
                            item.login_rule.holiday.allow_game_minutes_periods.forEach(times => {
                                data.identified_user_rules[index].login_rule.holiday.rules.push(
                                    this.initLoginRules({
                                        date_type: 3,
                                        start_time: times[0],
                                        end_time: times[1]
                                    }).login_rule
                                )
                            })
                        }

                        //work_day_normal......
                        console.log("work_day_normal......");
                        data.identified_user_rules[index].login_rule.work_day_normal.changeTimeOptions = this.initLoginRules({}).changeTimeOptions;
                        data.identified_user_rules[index].login_rule.work_day_normal.rules = [];
                        console.log(data.identified_user_rules[index]);

                        const keys_normal = Object.keys(item.login_rule.work_day_normal);
                        console.log(keys_normal);

                        keys_normal.forEach(key => {
                            if (key === 'daily_max_game_minutes') {
                                data.identified_user_rules[index].login_rule.work_day_normal.rules.push(
                                    this.initLoginRules({
                                        date_type: 1,
                                        daily_max_game_time: item.login_rule.work_day_normal[key]
                                    }).login_rule)
                            }
                        });
                        console.log(data.identified_user_rules[index]);

                        this.changeTimeRange(false, data.identified_user_rules[index], 'work_day_normal');
                        if (Array.isArray(item.login_rule.work_day_normal.forbidden_game_minutes_periods) &&
                            item.login_rule.work_day_normal.forbidden_game_minutes_periods.length) {
                            item.login_rule.work_day_normal.forbidden_game_minutes_periods.forEach(times => {
                                data.identified_user_rules[index].login_rule.work_day_normal.rules.push(
                                    this.initLoginRules({
                                        date_type: 2,
                                        start_time: times[0],
                                        end_time: times[1]
                                    }).login_rule)
                            })
                        }
                        if (Array.isArray(item.login_rule.work_day_normal.allow_game_minutes_periods) &&
                            item.login_rule.work_day_normal.allow_game_minutes_periods.length) {
                            item.login_rule.work_day_normal.allow_game_minutes_periods.forEach(times => {
                                data.identified_user_rules[index].login_rule.work_day_normal.rules.push(
                                    this.initLoginRules({
                                        date_type: 3,
                                        start_time: times[0],
                                        end_time: times[1]
                                    }).login_rule)
                            })
                        }

                        //work_day_special......
                        data.identified_user_rules[index].login_rule.work_day_special.changeTimeOptions = this.initLoginRules({}).changeTimeOptions;
                        data.identified_user_rules[index].login_rule.work_day_special.rules = [];
                        console.log(data.identified_user_rules[index]);

                        const keys_special = Object.keys(item.login_rule.work_day_special);
                        console.log(keys_special);

                        keys_special.forEach(key => {
                            if (key === 'daily_max_game_minutes') {
                                data.identified_user_rules[index].login_rule.work_day_special.rules.push(
                                    this.initLoginRules({
                                        date_type: 1,
                                        daily_max_game_time: item.login_rule.work_day_special[key]
                                    }).login_rule)
                            }
                        });
                        console.log(data.identified_user_rules[index]);

                        this.changeTimeRange(false, data.identified_user_rules[index], 'work_day_special');
                        if (Array.isArray(item.login_rule.work_day_special.forbidden_game_minutes_periods) &&
                            item.login_rule.work_day_special.forbidden_game_minutes_periods.length) {
                            item.login_rule.work_day_special.forbidden_game_minutes_periods.forEach(times => {
                                data.identified_user_rules[index].login_rule.work_day_special.rules.push(
                                    this.initLoginRules({
                                        date_type: 2,
                                        start_time: times[0],
                                        end_time: times[1]
                                    }).login_rule)
                            })
                        }
                        if (Array.isArray(item.login_rule.work_day_special.allow_game_minutes_periods) &&
                            item.login_rule.work_day_special.allow_game_minutes_periods.length) {
                            item.login_rule.work_day_special.allow_game_minutes_periods.forEach(times => {
                                data.identified_user_rules[index].login_rule.work_day_special.rules.push(
                                    this.initLoginRules({
                                        date_type: 3,
                                        start_time: times[0],
                                        end_time: times[1]
                                    }).login_rule)
                            })
                        }

                    })

                    data.names = [];
                    this.params = cloneDeep(data);
                    data.identified_user_rules.forEach((_, i) => {
                        this.params.names.push(i)
                    })
                    if (!res.id) {
                        this.is_edit = false;
                    } else {
                        this.params.id = res.id;
                        this.is_edit = true;
                    }
                    console.log(isEdit)

                    console.log("data");
                    console.log(data);

                    console.log("this.params");
                    console.log(this.params);

                    this.is_configured = isEdit;
                })
            }
        },
        created() {
            this.initAntiAddictionConfig();
        }
    }
</script>

<style lang="scss">
    .flex {
        display: flex;
        align-items: center;
    }

    .basis-config-item {
        .el-form-item__label {
            padding: 0;
        }
        .span-pad {
            margin-right: 12px;
        }
    }

    .dialog-configuration {
        .config, .el-dialog__body {
            padding: 0;
        }
        .el-card {
            border: none;
            box-shadow: none;
        }
    }

    .form-inline {
        display: inline-block;
        margin-bottom: 0;
    }
</style>

<style lang="scss">
    .greenitem .el-form-item__label {
        color: green;
    }
</style>
<style lang="scss">
    .config {
        padding: 14px 30px 30px;
        .config-card-box {
            h3 {
                margin: 14px 0;
            }
            h4 {
                margin-bottom: 12px;
            }
            .mar-t-0 {
                margin-top: 0;
            }
            .w50 {
                width: 50px;
            }
            .w70 {
                width: 70px;
            }
            .w120 {
                width: 120px;
            }
            .border-card {
                border: 1px dashed #EBEEF5;
                padding: 12px 20px;
                margin: 12px 0;
                border-radius: 6px;
                .el-form-item {
                    margin-bottom: 0;
                }
                .el-icon-circle-plus-outline, .el-icon-delete {
                    font-size: 20px;
                    cursor: pointer;
                }
                .el-icon-delete {
                    color: #ff4d51;
                    margin: 0 8px 0 4px;
                }
                .el-icon-circle-plus-outline {
                    color: #409EFF;
                    margin: 0 4px 0 8px;
                }
            }

            .title-change-btn {
                flex: 1;
                justify-content: space-between;
            }
            .submit-btn-box {
                margin-top: 12px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// website/subComponents/antiAddiction/configuration.vue